export const getLessorApi = (params, query) => {
    // const queryString = new URLSearchParams(query).toString();
    return `/lease/${params}/lessor`;
};
export const getAttachmentsApi = (leaseSlug) => {
    return `/2/tywte76/lease-details/${leaseSlug}/`;
};

export const putLessorApi = (params,query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params}/lessor${queryString ? `?${queryString}` : ""}`;
}

export const getLessorDropdown = () => {
    return `api/dropdown/lessor/`;
}
export const getOwnerDropdown = () => {
    return `api/dropdown/owner/`;
}

export const getLesseeApi = (params, query) => {
    return `/lease/${params}/lessee`;
};

export const putLesseeApi = (params,query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params}/lessee${queryString ? `?${queryString}` : ""}`;
}

export const getLesseeDropdown = () => {
    return `api/dropdown/lessee/`;
}

export const getLeaseDetailsApi = (params, query) => {
    return `/lease/${params}/lease-details`;
}

export const putLesseeDetailsApi = (params,query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/lease/${params}/lease-details${queryString ? `?${queryString}` : ""}`;
}

export const defaultBankDropdown = () => {
    return `api/dropdown/banks/`
}

export const getConsantApi = () => {
    return `lease/constants/get_by_constant_types`;
}
export const getBillableAssembliesApi = (leaseSlug) => {
    return `console/${leaseSlug}/major-assembly`;
}

export const headlinesFileUploadPostApi = (lease_slug) => {
    return `/get-pre-signed-url/lease/${lease_slug}`;
};

export const updateAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/lease/${attachments_slug}`
}
export const getCapeTownConventionApi=(params,query)=>{
    const queryString = new URLSearchParams(query).toString();
    return `/lease/${params}/cape-town-convention${queryString?`?${queryString}`:""}`;
}
export const putCapeTownConventionApi=(params)=>{
    return `/lease/${params}/cape-town-convention`;
}

export const getEngineRightApi = (params) => {
    return `lease/${params}/engine-rights/`;
}
export const updateEngineRightApi = (params) => {
    return `lease/${params}/engine-rights/`;
}
export const lgGroupingApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/grouping/${queryString ? `?${queryString}` : ""}`;
}
